export default interface IModel {
    Name: string;
    Id: string;
    Priority: number;
    makePriority: number;
}

export class Model {
    Name: string;
    Id: string;
    Priority: number = -1;
    makePriority: number = -1;

    constructor(name: string, id: string, Priority?: number, makePriority?: number) {
        this.Name = name;
        this.Id = id;
        if (Priority) {
            this.Priority = Priority;
        }
        if (makePriority) {
            this.makePriority = makePriority;
        }
    }

    public static copy(model: IModel) {
        return new Model(model.Name, model.Id, model?.Priority, model?.makePriority);
    }
}